<template>
  <fragment v-if="canDisplayPromotionalPackage">
    <td scope="row" class="productForm__itemName">
      <div class="productForm__itemName--wrapper">
        <!-- <img class="d-none" :src="product.image" :alt="product.name" @error="replaceImgWithDefault" v-if="!(isProductDeliveryPointsNumber || isProductPromoPacket)"> -->
        <!-- <img class="d-none" :src="productImageUrl" :alt="product.name" @error="replaceImgWithDefault" v-if="!(isProductDeliveryPointsNumber || isProductPromoPacket)"> -->
        <!-- <img class="d-none" src="/media/portfelik_wn23.png" alt="Pakiet promocji" @error="replaceImgWithDefault" v-else-if="isProductPromoPacket"> -->
        <div>
          {{ product.name }}
          <small class="small" v-if="product.label"> {{product.label}}</small>
          <span>
            <promo-packet-modal v-if="isProductPromoPacket"></promo-packet-modal>
          </span>
          <a
            v-if="canRemove"
            href="#"
            role="button"
            class="remove-product"
            @click.prevent="removeItem"
          >
            <span class="mi mi-trash"></span>
            Usuń kartę
          </a>
        </div>
      </div>
    </td>
    <td class="productForm__itemValue" data-label="Liczba">
      <tooltip text="Musisz być zalogowany, aby zwiększyć liczbę punktów dostaw" :enable="showToolTip">
        <ValidationProvider
          :rules="'required|min:0|promoQuantity:'+getQuantityMrk+','+product.product_category"
          v-slot="{ errors, classes }"
        >
          <InputSpinners
            @increase="handleIncreaseQuantity"
            @decrease="handleDecreaseQuantity"
            :disabled="getDisabled"
          >
            <input
              type="number"
              :min="product.product_category === 'AD' ? 1 : 0"
              :max="product.product_category === 'AD' ? 10 : 100000"
              name="productQuantity"
              class="form-control"
              :class="classes"
              v-model.number="inputQuantity"
              @input="handleChange($event)"
              @wheel="$event.target.blur()"
              :disabled="getDisabled"
              onfocus="this.select();"
              ref="productQuantityRef"
            >
          </InputSpinners>
          <span class="text-danger error-message" v-for="(error, index) in errors" :key="index">{{ error }}</span>
        </ValidationProvider>
      </tooltip>
    </td>
    <td class="productForm__itemQuantity" data-label="Wartość">
      <ValidationProvider
        :rules="'required|min:0'"
        v-slot="{ errors, classes }"
        v-if="isProductNDEExternalDistribution || isProductPhysicalCard || product.product_category === 'ECV_ISS'"
      >
        <input
          type="number"
          name="productChargeValue"
          class="form-control"
          :class="classes"
          :min="0"
          :max="product.product_category === 'AD' ? 10 : 100000"
          step="0.01"
          v-if="isProductNDEExternalDistribution || isProductPhysicalCard || product.product_category === 'ECV_ISS'"
          v-model.number="inputCharge"
          @change="handleChange($event)"
          @wheel="$event.target.blur()"
          onfocus="this.select();">
        <span class="text-danger error-message" v-for="(error, index) in errors" :key="index">{{ error }}</span>
      </ValidationProvider>

      <span v-if="!isProductNDEExternalDistribution && !isProductPhysicalCard && product.product_category !== 'ECV_ISS'  && product.product_category !== 'AD'">
        {{(inputCharge === 0)?'bezpłatnie':inputCharge}}
      </span>
    </td>
    <td class="productForm__itemPrice" data-label="Suma">
      <span v-if="product.product_category !== 'AD' && product.product_category !== 'MRK'">{{(inputQuantity * inputCharge).toFixed(2) }} zł</span>
    </td>
  </fragment>
</template>

<script>
import { mapState } from 'vuex';
import { extend } from 'vee-validate';
import PromoPacketModal from '../Modals/PromoPacketModal.vue';
import { DataLayerManager } from '@/utils/DataLayerManager';
import InputSpinners from '../Inputs/InputSpinners.vue';
import { PHYSICAL_CARD_CATEGORY, NDE_PHYSICAL_CATEGORY } from '@/utils/categoryUtils';

extend('min_value', {
  params: ['min'], // list of parameter names
  validate(value, { min }) {
    return Number(value) >= min;
  },
  message: 'Niepoprawna wartość',
});

extend('max_value', {
  params: ['max'], // list of parameter names
  validate(value, { max }) {
    return Number(value) <= max;
  },
  message: 'Niepoprawna wartość',
});

export default {
  name: 'ProductRowForm',
  components: {
    PromoPacketModal,
    InputSpinners,
  },
  props: ['product', 'delivery_id', 'main'],
  data() {
    return {
      inputQuantity: 0,
      lastQuantity: 0,
      inputCharge: 0,
    };
  },
  created() {
    this.product.id = this.product.idproducts;
    this.syncInputsWithStore();
  },
  computed: {
    ...mapState({
      isGuest: state => state.cart.userIsGuest,
    }),
    isProductPhysicalCard() {
      return [NDE_PHYSICAL_CATEGORY, PHYSICAL_CARD_CATEGORY].includes(this.product.product_category);
    },
    isProductNDEExternalDistribution() {
      return this.$store.getters.isProductNDEExternalDistribution;
    },
    isProductDeliveryPointsNumber() {
      return this.product.product_category === 'AD';
    },
    isProductPromoPacket() {
      return this.product.product_category === 'MRK';
    },
    showToolTip() {
      return this.isProductDeliveryPointsNumber && this.isGuest;
    },
    productImageUrl() {
      return `${process.env.VUE_APP_BASE_URL}/img/PLUXEE_${this.product.slug}.svg`;
    },
    canRemove() {
      const regex = /[[\d]+[-][\d]/g;
      const found = this.product.idproducts.toString()
        .match(regex);

      return Array.isArray(found);
    },
    getDisabled() {
      return this.product.idproducts === 1000002 && this.$store.getters['cart/getUserIsGuest'];
    },
    canDisplayPromotionalPackage() {
      // Karta dla Dzieci
      if (this.$store.getters.allProducts[0].idproducts === 28898 && this.product.idproducts === 1000001) {
        return false;
      }
      // Do not display delivery quantity on delivery address
      if (this.main === true && this.product.idproducts === 1000002) {
        return true;
      }
      const promoPacketsProduct = [26, 2, 25, 1];
      const type = this.$store.getters.getType;

      if (this.product.idproducts !== 1000001) {
        return true;
      }

      if (promoPacketsProduct.indexOf(parseInt(type, 10)) >= 0) {
        return true;
      }
      return false;
    },
    getQuantityMrk() {
      const summary = this.$store.getters['delivery/productSummary'](this.$props.delivery_id);
      return summary.quantity;
    },
    deliveryProductSnapshot() {
      const product = this.getProductFromDelivery();
      if (!product) {
        return null;
      }

      return {
        quantity: product.quantity,
        price: product.price,
      };
    },
  },
  methods: {
    syncInputsWithStore() {
      const product = this.getProductFromDelivery();

      if (product) {
        const quantity = Number(product.quantity) || 0;
        const price = Number(product.price);

        this.inputQuantity = quantity;
        this.lastQuantity = quantity;
        this.inputCharge = Number.isNaN(price) ? (Number(this.product.price) || 0) : price;
        return;
      }

      const fallbackQuantity = this.product.idproducts === 1000002
        ? Number(this.$store.getters['cart/getDeliveryNumber']) || 0
        : 0;

      this.inputQuantity = fallbackQuantity;
      this.lastQuantity = fallbackQuantity;
      this.inputCharge = Number(this.product.price) || 0;
    },
    replaceImgWithDefault(e) {
      e.target.src = `${process.env.VUE_APP_BASE_URL}/img/PLUXEE_fallback.svg`;
    },
    handleIncreaseQuantity() {
      this.updateInputQuantity(this.inputQuantity + 1);
    },
    handleDecreaseQuantity() {
      this.updateInputQuantity(this.inputQuantity - 1);
    },
    updateInputQuantity(quantity) {
      const min = parseInt(this.$refs.productQuantityRef.min, 10);
      const max = parseInt(this.$refs.productQuantityRef.max, 10);
      if (quantity < min || quantity > max) return;
      const event = new Event('input', { bubbles: true });
      event.value = quantity;
      this.$refs.productQuantityRef.value = event.value;
      this.$refs.productQuantityRef.dispatchEvent(event);
    },
    handleChange(e) {
      let quantity = e.target.name === 'productQuantity' ? e.target.value : this.inputQuantity;
      let charge = e.target.name === 'productChargeValue' ? e.target.value : this.inputCharge;
      if (quantity === '') {
        quantity = 0;
        this.inputQuantity = 0;
      }
      if (charge === '') {
        charge = 0;
        this.inputCharge = 0;
      }
      const newProduct = {};
      newProduct.id = this.product.idproducts;
      newProduct.quantity = parseFloat(quantity);
      newProduct.price = parseFloat(charge);
      newProduct.name = this.product.name;
      newProduct.iddelivery = parseFloat(this.$props.delivery_id);
      newProduct.product_category = this.product.product_category;
      newProduct.analyticsData = this.product.analyticsData;

      this.$store.dispatch('delivery/addProductToCart', newProduct);

      if (this.inputCharge && this.lastQuantity > this.inputQuantity) {
        const quantityDiff = this.lastQuantity - this.inputQuantity;
        DataLayerManager.pushRemoveCartEvent(newProduct, quantityDiff);
      } else if (this.inputCharge && this.lastQuantity < this.inputQuantity) {
        const quantityDiff = this.inputQuantity - this.lastQuantity;
        DataLayerManager.pushAddToCartEvent(newProduct, quantityDiff);
      }

      if (e.target.name === 'productChargeValue' && this.inputQuantity) {
        DataLayerManager.pushAddToCartEvent(newProduct);
      }

      this.lastQuantity = this.inputQuantity;

      /* if (this.product.idproducts === 1000001) {
        const summary = this.$store.getters['delivery/productSummary'](this.$props.delivery_id);
        if (summary.quantity < summary.quantityMrk)
          this.$refs.quantityProductValidator.setErrors(['Liczba pakietów nie może być większa od ilości szt.']);
        else
          this.$refs.quantityProductValidator.setErrors([]);
      } */

      if (this.product.idproducts === 1000002) {
        this.$store.dispatch('cart/setDeliveryNumber', this.inputQuantity);
      }
    },
    removeItem() {
      const removedProduct = this.getProductFromDelivery();
      this.$store.dispatch('removeProduct', [this.product, this.$props.delivery_id]);
      this.$store.dispatch('delivery/deleteProductFromCart', [this.product, this.$props.delivery_id]);
      DataLayerManager.pushRemoveCartEvent(this.product, removedProduct.quantity);
    },
    getProductFromDelivery() {
      return this.$store.getters['delivery/getValue'](Number(this.$props.delivery_id), this.product.idproducts)[0];
    },
  },
  watch: {
    deliveryProductSnapshot() {
      this.syncInputsWithStore();
    },
  },
};
</script>

<style scoped>

</style>
